import { render, staticRenderFns } from "./informationdetail.vue?vue&type=template&id=249f92b9&scoped=true&"
import script from "./informationdetail.vue?vue&type=script&lang=js&"
export * from "./informationdetail.vue?vue&type=script&lang=js&"
import style0 from "./informationdetail.vue?vue&type=style&index=0&id=249f92b9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249f92b9",
  null
  
)

component.options.__file = "informationdetail.vue"
export default component.exports